import {
  PURCHASING_PRODUCT_REQUEST,
  PURCHASING_PRODUCT_SUCCESS,
  PURCHASING_PRODUCT_FAILURE,
  PURCHASING_SET_DATERANGE_FILTERS_SUCCESS,
  PURCHASING_FILTERS_CLEAR,
} from "./actions";

import createReducer from "state/createReducer";

const initialState = {
  productGroups: [],
  errorMessage: null,
  activeFilters: {},
  filters: {},
  request: false,
};

const handlers = {
  [PURCHASING_PRODUCT_REQUEST](state, payload) {
    return {
      ...state,
      request: true,
      errorMessage: null,
    };
  },

  [PURCHASING_PRODUCT_SUCCESS](state, payload) {
    return {
      ...state,
      request: false,
      errorMessage: null,
      filters: payload.filters,
      productGroups: payload.productGroups,
    };
  },

  [PURCHASING_PRODUCT_FAILURE](state, payload) {
    return {
      ...state,
      request: true,
      errorMessage: payload.errorMessage,
    };
  },

  [PURCHASING_SET_DATERANGE_FILTERS_SUCCESS](state, payload) {
    const newActiveFilters = { ...state.activeFilters };
    newActiveFilters["daterange"] = {
      startDate: payload.startDate,
      endDate: payload.endDate,
    };

    return {
      ...state,
      activeFilters: newActiveFilters,
    };
  },

  [PURCHASING_FILTERS_CLEAR](state) {
    const activeFilters = { ...state.activeFilters };

    Object.keys(activeFilters).forEach((v) => {
      activeFilters[v] = [];
    });

    delete activeFilters["daterange"];
    return {
      ...state,
      activeFilters: activeFilters,
    };
  },
};

export default (state = initialState, action) =>
  createReducer(state, action, handlers);
